"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _theme = require("../theme");
/**
 * @param checked
 * @param color
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
    color = _ref.color,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/_react["default"].createElement(_reactSwitch["default"], {
    checked: checked || false,
    onChange: onChange,
    onColor: color || _theme.colors.lightGreen,
    onHandleColor: "#FFF",
    uncheckedIcon: false,
    checkedIcon: false,
    disabled: disabled
  });
};
var _default = exports["default"] = Switch;